import angular from 'angular';

class communityLayoutCtrl {
    /* @ngInject */
    constructor($rootScope, $scope, $state, $translate, CommunitySvc, AuthSvc) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;

        this.CommunitySvc = CommunitySvc;
        this.AuthSvc = AuthSvc;
    }

    $onInit() {
        this.menuItemsCommunity = this.CommunitySvc.getMenuItemsCommunity();
        this.$rootScope.$watch(
            () => {
                return this.$state.current;
            },
            () => this.setTitle()
        );

        this.$rootScope.$watch(
            () => {
                return this.CommunitySvc.getMenuItemsCommunity();
            },
            () => {
                this.menuItemsCommunity = angular.copy(this.CommunitySvc.getMenuItemsCommunity());
            }
        );
    }

    getCommunity() {
        return this.CommunitySvc.getCommunityByEid();
    }

    setTitle() {
        var titleByState = new Map();
        titleByState.set('community.new.create', 'community.detail.title');
        titleByState.set('community.details.main', 'community.detail.title_update');
        titleByState.set('community.details.companies', 'community.companies.title');
        titleByState.set('community.details.portal', 'community.detail.title_update');
        titleByState.set('community.details.stock-software-list', 'community.stock_software.title');
        titleByState.set('community.details.stock-software-update', 'Modification logiciel de stock agréé DiagDirect');
        titleByState.set('community.details.stock-software-create', 'Création logiciel de stock agréé DiagDirect');
        titleByState.set('community.details.personalise', 'community.personalise.title');
        titleByState.set('community.details.groupement-list', 'community.groupement.title');
        titleByState.set('community.details.groupement-create', 'community.groupement.create');
        titleByState.set('community.details.groupement-update', 'community.groupement.update');
        titleByState.set('community.details.referential', 'community.referential.title');
        titleByState.set('community.details.desadvparam', 'community.desadv.title');

        if (
            this.$state &&
            this.$state.current &&
            this.$state.current.name &&
            titleByState.has(this.$state.current.name)
        ) {
            this.title = titleByState.get(this.$state.current.name);
        }
    }
}

angular.module('app.community').component('communityLayout', {
    templateUrl: require('./community-layout.html'),
    controller: communityLayoutCtrl,
    bindings: {},
});
